module.exports = __webpack_public_path__ + "img/Sport,  Freizeit & Reisen.6ea3cca8.jpg";